export default function formatDuration(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.round(seconds % 60);

  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}min`);
  if (remainingSeconds > 0) parts.push(`${remainingSeconds}s`);

  if (parts.length === 0) return '0s';

  return parts.join(' ');
}
